import React, { useCallback, useEffect, useRef, useState } from 'react';
import { MessageBus } from '@podium/browser';

import {
    useExternalClickTracking,
    useInstanceId, useTrackInscreen,
} from '../../hooks';
import Tracking from '../../tracking';

const MB_CHANNEL_NATIVE_AD = 'recirc-native-ad';

type NativeAdProps = {
    ad: import('../../types').Recommendation;
    trackAdClick: (adId: string, trackingUrlClick: string[]) => void;
    tracking: Tracking;
    position: string;
};

let messageBus

const NativeAd: React.FC<NativeAdProps> = (props) => {
    const { tracking, ad, position, trackAdClick } = props;
    const domRef = useRef<HTMLDivElement>(null);

    const inscreenTrackingUrls = Tracking.getInscreenUrl(ad);
    const trackingUrlClick = Tracking.getClickUrl(ad);
    const instanceId = useInstanceId((id) => `ad-stream__native-ad-${id}`);

    const [loadFailed, setLoadFailed] = useState(false);

    useTrackInscreen({
        adId: ad.itemId,
        ref: domRef,
        tracking,
        enabled: !loadFailed,
        inscreenTrackingUrls,
        pulseContext: ad?.tracking?.pulse,
    });

    useExternalClickTracking({
        adId: ad.itemId,
        ref: domRef,
        enabled: !loadFailed,
        trackAdClick,
        trackingUrlClick,
        tracking,
        pulseContext: ad?.tracking?.pulse,
    });

    const handleAdLoadFailed = useCallback(() => {
        setLoadFailed(true)
    }, [])

    useEffect(() => {
        if (!messageBus) {
            messageBus = new MessageBus();
        }

        messageBus.publish(MB_CHANNEL_NATIVE_AD, 'init', {
            instanceId,
            position,
            keywords: {
                bap_main_category: ad.content.main_category,
                bap_product_category: ad.content.prod_category,
                bap_sub_category: ad.content.sub_category,
            }
        })
        messageBus.subscribe(MB_CHANNEL_NATIVE_AD, 'load-failed', handleAdLoadFailed);

        return () => {
            if (!messageBus) {
                messageBus = new MessageBus();
            }
            messageBus.unsubscribe(
                MB_CHANNEL_NATIVE_AD,
                'load-failed',
                handleAdLoadFailed,
            );
        };
    }, [ad, handleAdLoadFailed, instanceId, position]);

    if (loadFailed) return null;
    return (
        <div aria-hidden="true" className="h-full ads__unit" ref={domRef}>
            <slot name={instanceId} />
        </div>
    );
};

export default NativeAd;
